import { render, staticRenderFns } from "./SetAccount.vue?vue&type=template&id=c9c6b7f8&scoped=true&"
import script from "./SetAccount.vue?vue&type=script&lang=js&"
export * from "./SetAccount.vue?vue&type=script&lang=js&"
import style0 from "./SetAccount.vue?vue&type=style&index=0&id=c9c6b7f8&lang=less&scoped=true&"
import style1 from "./SetAccount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c6b7f8",
  null
  
)

export default component.exports